import { useEffect, useState } from "react";
import { fetchUpcomingBirthdays } from "./birthdayApi";
import BirthdayCelebration from "./BirthdayCelebration";

const GlobalBirthdayCelebration = () => {
  const [self, setSelf] = useState<{ name: string; storageKey: string } | null>(
    null,
  );

  useEffect(() => {
    let mounted = true;
    fetchUpcomingBirthdays()
      .then(({ all, todayKey }) => {
        const selfToday = all.find((p) => p.isSelf && p.isToday);
        if (mounted && selfToday && selfToday.name?.trim()) {
          const day = todayKey || new Date().toISOString().slice(0, 10);
          setSelf({
            name: selfToday.name,
            storageKey: `birthdayDismissed:${selfToday.id}:${day}`,
          });
        }
      })
      .catch((err) => {
        console.error("[birthday] global check failed", err);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!self) return null;

  return <BirthdayCelebration name={self.name} storageKey={self.storageKey} />;
};

export default GlobalBirthdayCelebration;
